import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  imports: [NgIf, MatProgressSpinner, AsyncPipe],
})
export class LoadingOverlayComponent implements OnInit {
  @Input() isLoading$?: Subject<boolean>;

  constructor() {}

  ngOnInit(): void {}
}
